import styled from 'styled-components';
import { EngineSelectStyled } from '../EngineSelectStyled';
import { rem } from 'polished';

export const EngineSelectStyledOV = styled(EngineSelectStyled)`
    .engine {
        border-color: ${({ theme }) => theme.colors.grey18};

        &.isSelected,
        &:hover,
        &:focus-visible {
            border-color: ${({ theme }) => theme.colors.black};
            .inner {
                border-color: ${({ theme }) => theme.colors.black};
            }
        }
    }

    .engineTitle {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        .icon {
            background: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
            .selected {
                background: ${({ theme }) => theme.colors.black};
                width: ${rem(8)};
                height: ${rem(8)};
                top: ${rem(7)};
                left: ${rem(7)};
            }
        }
    }

    .engineDescription {
        color: ${({ theme }) => theme.colors.grey2};
    }
    .enginePrice {
        color: ${({ theme }) => theme.colors.grey27};
    }

    .isSelected {
        background: ${({ theme }) => theme.colors.grey10};
    }
`;
